<template>
  <div class="Leaflet">

    <v-card-text
      v-if="loading"
      class="text-xs-center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-card-text>

    <div style="height: 90vh; width: 100%" v-else>
      <l-map
        class="l-map"
        :zoom="zoom"
        maxNativeZoom=18
        :center="center"
        :options="mapOptions"
        style="height: 100%"
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate"
      >
        <l-tile-layer
          :url="url"
          :attribution="attribution"
          :options="tileOptions"
        />

        <l-control position="bottomleft" >
          <v-container>
            <v-card v-if="maps_localidades" elevation-24 >

              <v-card-title primary-title>
                <h4>PORCENTAJE RIESGO COVID</h4>
              </v-card-title>

              <v-card-text>
                <v-layout align-space-between justify-start column fill-height>

                  <v-flex v-for="n in 5" :key="n">
                    <span class="font-weight-black  ">{{tabla_texto_riesgos[5-(n)]}}</span>
                    <v-icon small  :color="tabla_colores[max * (5-(n-1))]">lens</v-icon>
                    <span class=""> {{(max * (5-(n))).toFixed(2)}}% - {{(max * (5-(n-1))).toFixed(2)}}%</span>
                  </v-flex>

                </v-layout>
              </v-card-text>

            </v-card>

            <v-card v-else elevation-24>

              <v-card-title primary-title>
                <h4>LOCALIZACIÓN PERSONAL</h4>
              </v-card-title>

              <v-card-text>

                <v-layout align-space-between justify-start column >
                  <v-flex>
                    <span class="font-weight-black pa-3 ">Sin sintomas</span>
                    <v-icon color="light-green darken-2 " medium>place</v-icon>
                  </v-flex>

                  <v-flex>
                    <span class="font-weight-black  pa-3">Con sintomas</span>
                    <v-icon color="red accent-4" medium>place</v-icon>
                  </v-flex>
                </v-layout>
              </v-card-text>

            </v-card>
          </v-container>

          <v-btn round color="primary" dark @click="cambiarCapa">
            Cambiar capa
          </v-btn>
        </l-control>

        <l-control-scale position="topright" :imperial="false" :metric="true"></l-control-scale>

        <!-- <l-geo-json :geojson="localidades" :options="geoOptions"></l-geo-json> -->

        <template v-if="maps_localidades">

          <l-layer-group ref="features">
            <l-popup>
              <span>Localidad: {{l_num}} <br>{{l_nombre}}<br>Riesgo Covid: {{l_prob}}</span>
            </l-popup>
          </l-layer-group>
          <l-polygon
            v-for="pol in poligonos" :key="pol[0]"
            :lat-lngs="pol[1]"
            :color="pol[2]"
            :fillColor= "pol[2]"
            @click="openPopUp2((pol[1][1], pol[1][0]), pol[3], pol[0])"
          >
          </l-polygon>
        </template>

        <template v-else>

          <l-layer-group ref="features">
            <l-popup>
              <span>
                <h4>Nombre:</h4> {{p_nombre}}
                <br>
                <h4>Cédula: </h4>{{p_cedula}}
              </span>
            </l-popup>
          </l-layer-group>

          <template v-if="clustering">
            <l-marker-cluster :options="clusterOptions">
              <l-marker v-for="mark in markers" :key="mark[2]"
                :lat-lng="LatLongPoint(mark[1], mark[0])"
                @click="openPopUp(LatLongPoint(mark[1], mark[0]), mark[2])"
              >
                <l-icon
                  :icon-size="dynamicSize"
                  :icon-anchor="dynamicAnchor"
                >
                  <v-icon :color="mark[4]" size="60px">place</v-icon>
                </l-icon>

              </l-marker>

            </l-marker-cluster>
          </template>

          <template v-else>
            <l-marker v-for="mark in markers" :key="mark[2]"
              :lat-lng="LatLongPoint(mark[1], mark[0])"
              @click="openPopUp(LatLongPoint(mark[1], mark[0]), mark[2])"
            >
              <l-icon
                :icon-size="dynamicSize"
                :icon-anchor="dynamicAnchor"
              >
                <v-icon :color="mark[4]" size="60px">place</v-icon>
              </l-icon>
            </l-marker>
          </template>

        </template>
      </l-map>
    </div>

  </div>
</template>
<script>
// import JsonPretty from 'vue-json-pretty'
import moment from 'moment'
import { latLng } from 'leaflet'
import 'leaflet/dist/leaflet.css'

import { LMap, LIcon, LTileLayer, LLayerGroup, LControl, LControlScale, LMarker, LPopup, LPolygon } from 'vue2-leaflet'
// import { LMap, LTileLayer, LLayerGroup, LControlScale, LMarker, LPopup, LTooltip, LGeoJson } from 'vue2-leaflet'
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'

export default {
  name: `Leaflet`,

  components: {
    LMap,
    LTileLayer,
    LLayerGroup,
    LControlScale,
    LMarker,
    LPopup,
    LControl,
    // LGeoJson,
    LPolygon,
    LIcon,
    'l-marker-cluster': Vue2LeafletMarkerCluster
  },

  data: function () {
    return {
      path: './images/icono.png',
      backConf: {
        path: '/briefcase/localizacion',
        pathFiltro: '/charts/resumen_enc',
        pathHome: '/maps/localidad/?page=',
        pathMapa: '/projects/covid/mapa/',
        pathLocalidades: '/maps/localidad/',
        pathRiesgos: '/projects/covid/localidades/',
        pathPersona: '/projects/covid/persona/',
        page: 1
      },

      loading: false,
      progressSize: 70,
      progressWidth: 7,
      progressTotal: 0,
      progressAdvance: 0,
      completed: 0,

      operativo: null,

      panel: [false],

      dateIni: null,
      dateEnd: null,
      filter: [],

      filterBy: null,
      alert: false,

      markers: [],

      // Leaflet
      zoom: 7,
      center: latLng(4.60971, -74.08175),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors',
      withPopup: latLng(4.60871, -74.11379),
      withTooltip: latLng(4.60971, -74.08175),
      currentZoom: 7,
      currentCenter: latLng(4.60971, -74.08175),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        maxZoom: 23
      },
      tileOptions: {
        maxZoom: 23,
        maxNativeZoom: 19
      },
      geojson: null,

      clustering: true,
      clusterOptions: {},

      localidades: null,

      popupName: null,
      geoOptions: {
        style: function style (feature) {
          // return {
          //   weight: 4,
          //   opacity: 0.7,
          //   color: '#666',
          //   fillOpacity: 0.3
          // };

          // let loc = feature.id
          // if (loc < 8) {
          //   return {
          //     weight: 4,
          //     opacity: 0.7,
          //     color: '#ff0000',
          //     fillOpacity: 0.3
          //   }
          // } else if (loc < 15) {
          //   return {
          //     weight: 4,
          //     opacity: 0.7,
          //     color: '#00ff00',
          //     fillOpacity: 0.3
          //   }
          // } else {
          //   return {
          //     weight: 4,
          //     opacity: 0.7,
          //     color: '#0000ff',
          //     fillOpacity: 0.3
          //   }
          // }

          // if (feature.properties.selected) {
          //   return {
          //     weight: 4,
          //     opacity: 0.7,
          //     color: '#ff0000',
          //     fillOpacity: 0.3
          //   };
          // } else {
          //   return {
          //     weight: 4,
          //     opacity: 0.7,
          //     color: '#0080FF',
          //     fillOpacity: 0.3
          //   };
          // }
        },
        onEachFeature: (feature, layer) => {
          layer.on({
            click (e) {
              e.target.feature.properties.selected = !e.target.feature.properties.selected
              if (e.target.feature.properties.selected) {
                layer.setStyle({ opacity: 1, width: 3, fillColor: '#ff0000' })
              } else {
                layer.setStyle({ opacity: 1, width: 3, fillColor: '#0080FF' })
              }
            }
            // mouseover(e){
            //   this.setStyle({
            //     fillColor: '#ff0000',
            //     color: '#ff0000'
            //   });
            // },
            // mouseout(e){
            //   this.setStyle({
            //     fillColor: '#bf9946',
            //     color: '#bf9946'
            //   });
            // }
          })

          // var self = this;
          // layer.on('mouseover', function(e) {
          // self.popupName = feature.properties.Name;
          // // console.log(feature.properties.Name);
          // //open popup
          // var popup = L.popup()
          //   .setLatLng(e.latlng)
          //   .setContent('<h1 style="color: grey; margin-bottom: 0;">'+ feature.properties.Name +'</h1>')
          //   .openOn(self.$refs.myMapRef.mapObject)
          // })
        }
      },

      caller: null,
      selectedLoc: [],
      maps_localidades: false,
      poligonos: [],
      aux: null,
      taux: [],
      tabla_riesgos: [],
      tabla_colores: [],
      l_prob: null, // probabilidad de cada localidad
      l_nombre: null,
      l_num: null,
      p_nombre: null,
      p_cedula: null,
      token: null,

      iconSize: 64,

      max: null,
      color5: '#D50000',
      color4: '#E65100',
      color3: '#FFAB00',
      color2: '#FFEB3B',
      color1: '#64DD17',
      tabla_texto_riesgos: [
        'Muy Bajo',
        'Bajo',
        'Medio',
        'Alto',
        'Muy Alto'
      ]
    }
  },

  watch: {
    '$store.state.actualProject': function () {
      this.operativo = this.$store.state.actualProject.id
    },

    /**
     * Calcula el porcentaje de avacne
     * @return {float} porcentaje de avance
     */
    'markers': function () {
      this.completed = (this.progressAdvance / this.progressTotal) * 100
    }
  },

  computed: {
    /**
     * Verifica que la fecha final no sea anterior a la fecha inicial
     * @return {boolean} validación de las fechas
    */
    vDate: function vDate () {
      if (this.dateIni && this.dateEnd) {
        return moment(this.dateEnd).isBefore(this.dateIni)
      }
      return false
    },

    /**
     * Genera el objeto para realizar la consulta
     * @return {Object} Objeto de la forma id[field]:id[choice]
    */
    filterToApply: function filterToApply () {
      if (this.filter.length < 1) {
        return null
      }

      let obj = {}

      this.filterBy.forEach(function (filt, index) {
        obj[filt.id] = this.filter[index]
      }, this)
      return obj
    },

    dynamicSize () {
      return [this.iconSize, this.iconSize * 1.15]
    },
    dynamicAnchor () {
      return [this.iconSize / 2, this.iconSize * 1.15]
    }

    // selectedLoc: function selectedLoc () {
    //   let selected = []
    //
    //   this.localidades.features.forEach(function(loc, index) {
    //     if (loc.properties.selected){
    //       console.log(index, loc.properties.nombre, loc.properties.selected)
    //       selected.push(loc.properties.nombre)
    //     }
    //   })
    //
    //   return selected
    // }
  },
  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
    // this.loadFiltro()
    this.getMarkersWhithFilter()
    this.getRiesgosLocalidades()
    this.getPoligonosLocalidades()
  },

  methods: {
    /**
    * Devuelve el color respecto al nivel indicado segun
    * riesgo dentro de la tabla_colores
    */
    getColorR (riesgo) {
      let tt = Object.keys(this.tabla_colores)
      if (riesgo < tt[0]) {
        return this.tabla_colores[tt[0]]
      } else if (riesgo < tt[1]) {
        return this.tabla_colores[tt[1]]
      } else if (riesgo < tt[2]) {
        return this.tabla_colores[tt[2]]
      } else if (riesgo < tt[3]) {
        return this.tabla_colores[tt[3]]
      } else {
        return this.tabla_colores[tt[4]]
      }
    },

    /**
    * Obtiene el nombre y cedula de una persona mediante
    * su token
    */
    async getPersona () {
      let request = {
        method: 'get',
        url: this.backConf.pathPersona,
        params: {
          operativo: this.operativo,
          token: this.token
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.p_nombre = resp.data['nombre']
          t.p_cedula = resp.data['cedula']
        })
        .catch(function (err) {
          console.error(err)
        })
    },

    /**
     * Genera la tabla_riesgos de Localidades
     * Genera la tabla_colores
     * y Obtiene el numero Max que es la diferencia entre
     * el mayor dividido 5
    */
    getRiesgosLocalidades () {
      this.loading = true
      let request = {
        method: 'get',
        url: this.backConf.pathRiesgos
        // params: {
        //   operativo: this.operativo,
        // }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          let aux = resp.data.results
          t.max = 0
          for (const loc in aux) {
            t.tabla_riesgos[aux[loc]['localidad']] = aux[loc]
            if (t.max < aux[loc]['riesgo']) {
              t.max = aux[loc]['riesgo']
            }
          }
          t.max = t.max / 5
          t.tabla_colores[t.max] = t.color1
          t.tabla_colores[t.max * 2] = t.color2
          t.tabla_colores[t.max * 3] = t.color3
          t.tabla_colores[t.max * 4] = t.color4
          t.tabla_colores[t.max * 5] = t.color5
        })
        .catch(function (err) {
          console.error(err)
        })
    },

    /**
     * Recibe las coordenadas (poligonos) y mas propiedades de las localidades
     * y las asigna a un arreglo agregandole su respectivo color segun
     * porcentaje riesgo
    */
    getPoligonosLocalidades () {
      this.loading = true
      let request = {
        method: 'get',
        url: this.backConf.pathLocalidades,
        params: {
          operativo: this.operativo
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          let aux = resp.data.results.features

          for (const pol in aux) {
            let arr = []
            let coord = []
            let coordTODO = aux[pol].geometry.coordinates[0][0]

            for (let exp in coordTODO) {
              let arr2 = [coordTODO[exp][1], coordTODO[exp][0]]
              coord.push(arr2)
            }
            arr[0] = (aux[pol].id)
            arr[1] = Object.values(coord)
            let id = aux[pol].id
            arr[2] = t.getColorR(t.tabla_riesgos[id]['riesgo'])
            arr[3] = aux[pol].properties.nombre
            t.poligonos.push(arr)
          }
        })
        .catch(function (err) {
          console.error(err)
        })
    },

    /**
     * Limpia el arreglo de marcadores actual y llama a la función que realiza el get
     */
    getMarkersWhithFilter () {
      this.markers = []
      this.alert = false
      this.getMarkers()
    },

    cambiarCapa () {
      this.maps_localidades = !this.maps_localidades
    },

    /**
     * Carga las coordenadas de las personas en el operativo
     * junto con sus sintomas respectivos y color de marcador
     * segun porcentaje riesgo
     */
    getMarkers () {
      this.loading = true
      this.panel = [false]
      let request = {
        method: 'get',
        url: this.backConf.pathMapa,
        params: {
          operativo: this.operativo,
          fechainicio: this.dateIni,
          fechafin: this.dateEnd,
          filtro: this.filterToApply,
          page: this.backConf.page
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.progressTotal = resp.data.count
          t.progressAdvance = t.markers.length

          let ll = resp.data.results.features
          for (const e in ll) {
            let arr = []
            let x = ll[e]['geometry']['coordinates'][0]
            let y = ll[e]['geometry']['coordinates'][1]
            arr.push(x)
            arr.push(y)
            arr.push(ll[e]['properties']['token'])
            arr.push(ll[e]['properties']['temperatura'])
            let temp = parseFloat(ll[e]['properties']['temperatura'])
            let tos = ll[e]['properties']['tos']
            let comidas = ll[e]['properties']['comidas']
            let fatiga = ll[e]['properties']['fatiga']
            let gusto = ll[e]['properties']['gusto']
            if (tos === '0' && comidas === '0' && fatiga === '0' && gusto === '0' && temp < 37.5) {
              arr.push('light-green darken-2')
            } else {
              arr.push('red accent-4')
            }
            t.markers.push(arr)
          }

          t.backConf.page = 1

          if (resp.data.next !== null) {
            t.backConf.page += 1
            t.getMarkers()
          } else {
            t.backConf.page = 1
            t.progressTotal = 0
            t.progressAdvance = 0
            // t.loadFeatures()
            t.loading = false
          }
        })
        .catch(function (err) {
          t.markers = []
          // t.loadFeatures()
          t.alert = true
          t.loading = false
          t.backConf.page = 1
          t.mapkey += 1
          console.error(err)
        })
    },

    /**
     * Carga los filtros especificos
     */
    loadFiltro () {
      let request = {
        method: 'get',
        url: this.backConf.pathFiltro,
        params: {
          operativo: this.operativo,
          tipo: 'filtro'
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.filterBy = resp.data
        })
        .catch(function (err) {
          t.filterBy = null
          console.error(err)
        })
    },

    /**
     * Limpia todos los campos
     */
    clear () {
      this.dateIni = null
      this.dateEnd = null
      this.filter = []
    },

    // Leaflet
    zoomUpdate (zoom) {
      this.currentZoom = zoom
    },
    centerUpdate (center) {
      this.currentCenter = center
    },
    showLongText () {
      this.showParagraph = !this.showParagraph
    },

    LatLongPoint (lat, long) {
      return latLng(lat, long)
    },

    async loadGeo () {
      const response = await fetch('https://rawgit.com/gregoiredavid/france-geojson/master/regions/pays-de-la-loire/communes-pays-de-la-loire.geojson')
      this.geojson = await response.json()
    },
    /**
    * Funcion para poner en pop up propiedades
    * del marcador
    */
    openPopUp (latLng, caller) {
      this.p_cedula = null
      this.p_nombre = null
      console.log('token: ' + caller)
      this.token = caller
      this.getPersona()
      this.$refs.features.mapObject.openPopup(latLng)
    },
    /**
    * Funcion para poner en pop up propiedades
    * de la localidad
    */
    openPopUp2 (latLng, nombre, prob) {
      this.l_nombre = nombre
      this.l_num = prob

      console.log(prob)
      console.log(this.tabla_riesgos[prob])
      let text = this.tabla_riesgos[(prob)]['riesgo']

      this.l_prob = String(text) + ' %'
      this.$refs.features.mapObject.openPopup(latLng)
    },

    // del home
    cleanFeatures () {
      this.localidades = null
    },

    getAllFeatures () {
      this.loading = true
      let request = {
        method: 'get',
        url: this.backConf.pathHome,
        params: {
          page: this.backConf.page
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.localidades = resp.data.results
          t.loading = false
        })
        .catch(function (err) {
          t.localidades = null
          t.loading = false
          console.error(err)
        })
    },

    // pruebas
    printSelected () {
      console.log('Selected')
      this.localidades.features.forEach(function (loc, index) {
        if (loc.properties.selected) {
          console.log(index, loc.properties.nombre, loc.properties.selected)
          this.selectedLoc.push(loc.properties.nombre)
        }
      }, this)
      console.log(JSON.stringify(this.selectedLoc))
    }
  }
}
</script>

<style scoped>
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
  /* .Leaflet {
    text-align:left;
    height:85%;
    width:100%;
    position: absolute;
  } */
  /* .l-map {
    overflow:hidden;
    background:none!important;
    height:100%;
    width:100%;
  } */
  /* .totalMarks {
    position: absolute;
    top: 3px;
    left: 29px;
  } */
</style>
